import { useEffect, useState } from "react";

function useMatchMedia(query) {
  const get = () => (typeof window !== "undefined" && window.matchMedia ? window.matchMedia(query).matches : false);
  const [matches, setMatches] = useState(get);
  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, [query]);
  return matches;
}

// Small viewport helper for motion: mobile breakpoint + OS reduced-motion preference.
export function useViewport() {
  const isMobile = useMatchMedia("(max-width: 1023px)");
  const isPhone = useMatchMedia("(max-width: 639px)");
  const reduceMotion = useMatchMedia("(prefers-reduced-motion: reduce)");
  return { isMobile, isPhone, reduceMotion };
}
